import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import _Drawer from "@arco-design/web-react/es/Drawer";
import _Typography from "@arco-design/web-react/es/Typography";
import _Button from "@arco-design/web-react/es/Button";
import _Modal from "@arco-design/web-react/es/Modal";
import _Message from "@arco-design/web-react/es/Message";
import _Avatar from "@arco-design/web-react/es/Avatar";
import _Tag from "@arco-design/web-react/es/Tag";
import _Table from "@arco-design/web-react/es/Table";
import _Select from "@arco-design/web-react/es/Select";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState, useEffect } from 'react';
import { getPublishLog } from '@src/utils/api/publish';
import { ExecuteVersionBack, ResetThemeToVersion } from '@src/utils/api/theme';
import { formatDate } from '@src/utils/format';
import DiffTokenTable from '@src/design/common/themePublish/diffTokenTable';
import useLocale from '@src/hooks/useLocale';
import locale from './locale';
var Option = _Select.Option;
function PublishHistoryDrawer(props) {
  var themeId = props.theme.themeId;
  var _a = __read(useState(false), 2),
    loading = _a[0],
    setLoading = _a[1];
  var _b = __read(useState({
      list: [],
      userInfos: []
    }), 2),
    result = _b[0],
    setResult = _b[1];
  useEffect(function () {
    setLoading(true);
    getPublishLog({
      themeId: themeId
    }).then(function (result) {
      setResult(result);
      setLoading(false);
      props.setOptions(result.list);
    });
  }, []);
  var data = (result === null || result === void 0 ? void 0 : result.list) || [];
  var userInfos = (result === null || result === void 0 ? void 0 : result.userInfos) || {};
  return /*#__PURE__*/React.createElement(_Table, {
    rowKey: "_id",
    pagination: {
      showTotal: true,
      hideOnSinglePage: true
    },
    size: "middle",
    border: false,
    data: data,
    columns: [{
      dataIndex: 'version',
      title: '版本',
      width: 80,
      cellStyle: {
        paddingLeft: 0
      }
    }, {
      dataIndex: 'status',
      title: '发布状态',
      width: 100,
      render: function render(x) {
        return /*#__PURE__*/React.createElement(_Tag, {
          color: x === 'error' ? 'red' : 'green'
        }, x);
      }
    }, {
      dataIndex: 'operator',
      title: '发布人',
      ellipsis: true,
      width: 100,
      render: function render(x) {
        var ownerInfos = props.theme.ownerInfos;
        var info = userInfos[x] || ownerInfos.find(function (item) {
          return (item === null || item === void 0 ? void 0 : item.username) === x;
        });
        return !info ? x : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Avatar, {
          size: 20
        }, /*#__PURE__*/React.createElement("img", {
          src: info.avatar_url,
          alt: x
        })), /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 4
          }
        }, info.name));
      }
    }, {
      dataIndex: 'createdAt',
      title: '发布时间',
      width: 120,
      render: function render(v) {
        var _a = __read(formatDate(v, 'YYYY-MM-DD HH:MM:ss').split(' '), 2),
          date = _a[0],
          time = _a[1];
        return /*#__PURE__*/React.createElement("span", null, date, /*#__PURE__*/React.createElement("br", null), time);
      }
    }, {
      dataIndex: 'versionLog',
      title: '版本描述',
      render: function render(v) {
        return /*#__PURE__*/React.createElement("pre", {
          style: {
            whiteSpace: 'pre-wrap',
            maxHeight: 200,
            overflow: 'auto'
          }
        }, v);
      }
    }],
    loading: loading,
    expandedRowRender: function expandedRowRender(record) {
      return /*#__PURE__*/React.createElement(DiffTokenTable, {
        tableProps: {
          size: 'small'
        },
        data: record.tokens
      });
    },
    expandProps: {
      width: 40
    }
  });
}
var timer = -1;
function RollbackVersion(props) {
  var _this = this;
  var _a = __read(useState(false), 2),
    warningVisible = _a[0],
    setWarningVisible = _a[1];
  var _b = __read(useState(''), 2),
    rollbackVersion = _b[0],
    setRollbackVersion = _b[1];
  var _c = __read(useState(true), 2),
    btnDisabled = _c[0],
    setBtnDisabled = _c[1];
  var _d = __read(useState(false), 2),
    btnLoading = _d[0],
    setBtnLoading = _d[1];
  var delaySeconds = 5;
  var _e = __read(useState(String(delaySeconds)), 2),
    btnTxt = _e[0],
    setBtnTxt = _e[1];
  var t = useLocale(locale).t;
  var requestVersionBack = function requestVersionBack() {
    return __awaiter(_this, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setBtnDisabled(true);
            setBtnLoading(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4, ExecuteVersionBack({
              rollbackVersion: rollbackVersion,
              themeId: props.theme.themeId
            })];
          case 2:
            _a.sent();
            _Message.success(t['rollbackSuccessTip']);
            setTimeout(function () {
              location.reload();
            }, 1000);
            return [3, 4];
          case 3:
            error_1 = _a.sent();
            setBtnDisabled(false);
            setBtnLoading(false);
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  };
  var delayAction = function delayAction() {
    var seconds = delaySeconds;
    clearInterval(timer);
    setBtnDisabled(true);
    timer = window.setInterval(function () {
      seconds -= 1;
      if (seconds === 0) {
        setBtnTxt(t['rollbackWarningModalConfirm']);
        setBtnDisabled(false);
        clearInterval(timer);
      } else {
        setBtnTxt(String(seconds));
      }
    }, 1000);
  };
  var cancelAction = function cancelAction() {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        clearInterval(timer);
        setWarningVisible(false);
        setBtnTxt(String(delaySeconds));
        return [2];
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    style: {
      marginRight: 20
    }
  }, t['versionBackLabel']), /*#__PURE__*/React.createElement(_Select, {
    placeholder: t['versionBackPlaceholder'],
    style: {
      width: 154
    },
    onChange: function onChange(value) {
      if (!value) return;
      delayAction();
      setRollbackVersion(value);
      setWarningVisible(true);
    },
    allowClear: true
  }, props.options.map(function (option) {
    return /*#__PURE__*/React.createElement(Option, {
      key: option._id,
      value: option.version
    }, option.version);
  })), /*#__PURE__*/React.createElement(_Modal, {
    title: t['rollbackWarningModalTitle'],
    visible: warningVisible,
    focusLock: false,
    closable: false,
    onCancel: cancelAction,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Button, {
      style: {
        width: 80
      },
      onClick: cancelAction
    }, t['rollbackWarningModalCancel']), /*#__PURE__*/React.createElement(_Button, {
      style: {
        width: 80
      },
      loading: btnLoading,
      disabled: btnDisabled,
      onClick: requestVersionBack,
      type: "primary"
    }, btnTxt))
  }, /*#__PURE__*/React.createElement(_Typography.Paragraph, null, t['rollbackWarningModalLabel'], " ", /*#__PURE__*/React.createElement(_Tag, {
    color: "red"
  }, rollbackVersion)), /*#__PURE__*/React.createElement(_Typography.Paragraph, null, t['rollbackWarningModalDesc1']), /*#__PURE__*/React.createElement(_Typography.Paragraph, null, t['rollbackWarningModalDesc2']), /*#__PURE__*/React.createElement(_Typography.Paragraph, null, t['rollbackWarningModalDesc3']), /*#__PURE__*/React.createElement(_Typography.Paragraph, null, t['rollbackWarningModalDesc4'])));
}
var PublishHistory = function PublishHistory(props) {
  var _a = __read(useState(false), 2),
    visible = _a[0],
    setVisible = _a[1];
  var _b = __read(useState([]), 2),
    options = _b[0],
    setOptions = _b[1];
  var t = useLocale(locale).t;
  return /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      setVisible(true);
    }
  }, /*#__PURE__*/React.createElement("span", null, props.children), /*#__PURE__*/React.createElement("span", {
    onMouseLeave: function onMouseLeave(e) {
      e.stopPropagation();
    },
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(_Drawer, {
    title: t['drawerTitle'],
    footer: null,
    mountOnEnter: true,
    unmountOnExit: true,
    visible: visible,
    width: 725,
    onCancel: function onCancel() {
      setVisible(false);
    },
    onOk: function onOk() {
      setVisible(false);
    }
  }, props.theme.isMine && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 20,
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(RollbackVersion, {
    options: options,
    theme: props.theme
  }), /*#__PURE__*/React.createElement(_Popconfirm, {
    title: t['popconfirmTitle'],
    onOk: function onOk() {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, ResetThemeToVersion({
                themeId: props.theme.themeId,
                version: '0.0.0'
              })];
            case 1:
              _a.sent();
              props.onReset && props.onReset();
              return [2];
          }
        });
      });
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary"
  }, t['resetBtn']))), /*#__PURE__*/React.createElement(PublishHistoryDrawer, {
    theme: props.theme,
    setOptions: setOptions
  }))));
};
export default PublishHistory;